import { useEffect, useState, type RefObject } from 'react';

interface Interseccion {
    cruza: boolean;
    razon: number;
}

const FUERA: Interseccion = { cruza: false, razon: 0 };

/**
 * Visible en pantalla según un IntersectionObserver; solo observa si su árbol es el visible.
 * Con `umbral` 0 basta con que asome (el reloj de la Fase 17); el vídeo del héroe pide un 25 %
 * visible para no seguir reproduciéndose cuando apenas se ve (UI-SPEC §B.3). El estado guarda solo
 * lo que dice el observador; el umbral se aplica al leerlo.
 */
export function useEnPantalla(raizRef: RefObject<HTMLDivElement | null>, activo: boolean, umbral = 0): boolean {
    const [interseccion, setInterseccion] = useState<Interseccion>(FUERA);
    useEffect(() => {
        const raiz = raizRef.current;
        if (!activo || !raiz || typeof IntersectionObserver === 'undefined') return;
        const opciones = umbral === 0 ? undefined : { threshold: [0, umbral] };
        const observador = new IntersectionObserver(
            ([entrada]) => setInterseccion({ cruza: entrada.isIntersecting, razon: entrada.intersectionRatio }),
            opciones,
        );
        observador.observe(raiz);
        return () => observador.disconnect();
    }, [raizRef, activo, umbral]);
    return activo && interseccion.cruza && (umbral === 0 || interseccion.razon >= umbral);
}
